import { useTranslation } from 'react-i18next'

// Chat change VH-229 Q&A: the system proposes, the user edits. A user-set nutrition
// target keeps the computed value and its reason next to the user's value.
export function TargetOverrideNote({ target }) {
  const { t } = useTranslation()
  if (target?.source !== 'user') return null
  const computed = target.computed_value
  return (
    <span className="block text-xs text-purple-700" data-testid="target-override-note">
      <span className="font-medium">{t('cycleReports.nutrition.setByYou')}</span>
      {computed !== null && computed !== undefined && (
        <>
          {' · '}
          {t('cycleReports.nutrition.computedValue', {
            value: [computed, target.unit].filter(Boolean).join(' '),
            reason: t(`cycleReports.reasonCode.${target.reason_code}`, ''),
          })}
        </>
      )}
      {target.note && <span className="block text-gray-600">{target.note}</span>}
    </span>
  )
}

export default TargetOverrideNote
